import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "table table-bordered table-hover" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "dropdown" }
const _hoisted_8 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

import { ref, computed, onMounted, watch, shallowReactive } from 'vue'
    import { useRoute } from 'vue-router'
    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"
    import ProjectPlanTemplateEditor from '@Quest/ProjectPlanTemplates/Components/ProjectPlanTemplateEditor.vue'

    import { ProjectPlanTemplateData, ProjectPlanTemplateEditorViewModel } from '@Quest/ProjectPlanTemplates/Components/ProjectPlanTemplateEditor'
    import type { ProjectPlanTemplateReadModel, ProjectPlanTemplatesPageReadModel } from '@Quest/ProjectPlanTemplates/readmodels'
    import { useProjectPlanTemplatesPageQueryV1 } from '@Quest/ProjectPlanTemplates/queries-vue-composables'
    import { useCreateProjectPlanTemplateCommandV1, useUpdateProjectPlanTemplateCommandV1, useDeleteProjectPlanTemplateCommandV1 } from '@Quest/ProjectPlanTemplates/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectPlanTemplatesPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))

    const projectPlanTemplateEditor = shallowReactive(new ProjectPlanTemplateEditorViewModel())

    const {
        runProjectPlanTemplatesPageQueryV1,
        modelProjectPlanTemplatesPageQueryV1: rm
    } = useProjectPlanTemplatesPageQueryV1(workspaceId, strategyId)

    const {
        invokeCreateProjectPlanTemplateCommandV1,
        succeedCreateProjectPlanTemplateCommandV1
    } = useCreateProjectPlanTemplateCommandV1(workspaceId, strategyId)

    const {
        invokeUpdateProjectPlanTemplateCommandV1,
        succeedUpdateProjectPlanTemplateCommandV1
    } = useUpdateProjectPlanTemplateCommandV1(workspaceId, strategyId)

    const {
        invokeDeleteProjectPlanTemplateCommandV1,
        succeedDeleteProjectPlanTemplateCommandV1
    } = useDeleteProjectPlanTemplateCommandV1(workspaceId, strategyId)

    watch(
        [
            succeedCreateProjectPlanTemplateCommandV1,
            succeedUpdateProjectPlanTemplateCommandV1,
            succeedDeleteProjectPlanTemplateCommandV1
        ],
        ([create, update, del]) =>
        {
            if (create || update || del)
            {
                runProjectPlanTemplatesPageQueryV1()
                projectPlanTemplateEditor.close()
            }
        }
    )

    function showProjectPlanTemplateCreator()
    {
        projectPlanTemplateEditor.showCreator()
    }

    function showProjectPlanTemplateEditor(t: ProjectPlanTemplateReadModel)
    {
        projectPlanTemplateEditor.showEditor(t)
    }

    function handleCreateProjectPlanTemplateCommand(p: ProjectPlanTemplateData)
    {
        invokeCreateProjectPlanTemplateCommandV1({
            Id: p.Id,
            name: p.Name,
            description: p.Description,
            durationInMonths: p.DurationInMonths,
            granularity: p.Granularity,
            denomination: p.Denomination
        })
    }

    function handleUpdateProjectPlanTemplateCommand(p: ProjectPlanTemplateData)
    {
        invokeUpdateProjectPlanTemplateCommandV1({
            Id: p.Id,
            name: p.Name,
            description: p.Description,
            durationInMonths: p.DurationInMonths,
            granularity: p.Granularity,
            denomination: p.Denomination
        })
    }

    function handleDeleteProjectPlanTemplateCommand(t: ProjectPlanTemplateReadModel)
    {
        if (confirm("Are you sure?"))
        {
            invokeDeleteProjectPlanTemplateCommandV1({ Id: t.Id })
        }
    }

    onMounted(() =>
    {
        document.title = "Enterprise business case templates"
        runProjectPlanTemplatesPageQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ProjectPlanTemplateEditor, {
      viewModel: _unref(projectPlanTemplateEditor),
      onCreateTemplate: handleCreateProjectPlanTemplateCommand,
      onUpdateTemplate: handleUpdateProjectPlanTemplateCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(CorporateNavigation, { ActivePage: "strategy" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", { class: "row" }, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-6" }, [
              _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Business case templates")
            ], -1 /* CACHED */)),
            _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-success",
                style: {"padding":"0.7em 2em"},
                onClick: showProjectPlanTemplateCreator
              }, "Create a template")
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "align-top" }, "Template"),
                  _createElementVNode("th", { class: "align-top text-center" }, "Granularity"),
                  _createElementVNode("th", { class: "align-top text-center" }, "Denomination"),
                  _createElementVNode("th", { class: "align-top text-center" }, [
                    _createTextVNode("Project execution"),
                    _createElementVNode("br"),
                    _createTextVNode(),
                    _createElementVNode("small", { class: "text-muted" }, "in months")
                  ]),
                  _createElementVNode("th", { style: {"width":"120px"} })
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Templates, (t) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: t.Id
                  }, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(t.Name), 1 /* TEXT */),
                      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createTextVNode(" " + _toDisplayString(t.Description), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_4, _toDisplayString(t.Granularity), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_5, _toDisplayString(t.Denomination), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(t.DurationInMonths), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[2] || (_cache[2] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Actions ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (showProjectPlanTemplateEditor(t))
                          }, "Edit", 8 /* PROPS */, _hoisted_9),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (handleDeleteProjectPlanTemplateCommand(t))
                          }, "Delete", 8 /* PROPS */, _hoisted_10)
                        ])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})